var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-new": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("outstanding-credit-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "tile is-parent" }, [
                _c(
                  "article",
                  { staticClass: "tile is-child box" },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "total-rows": _vm.totalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(
                          _vm.outstandingcreditSummaries,
                          function (outstandingcredit, index) {
                            return _c(
                              "tr",
                              {
                                key: outstandingcredit.invoiceRef,
                                class: {
                                  "is-selected": _vm.selectedRow === index,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.highlightSelected(index, $event)
                                  },
                                },
                              },
                              [
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(
                                            outstandingcredit.creditReturnMainID
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(outstandingcredit.invoiceRef)
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(outstandingcredit.creditorName)
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatDateTimezone(
                                        outstandingcredit.invoiceDate,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatNumberWithRounding(
                                        outstandingcredit.balance,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumberWithRounding(
                                          outstandingcredit.totalAmount,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumberWithRounding(
                                          outstandingcredit.gstAmount,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumberWithRounding(
                                          outstandingcredit.amount,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("td", { staticClass: "has-text-centered" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(outstandingcredit.purchaseOrderNo)
                                    ),
                                  ]),
                                ]),
                                _c("td", { staticClass: "has-text-centered" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button is-primary is-small is-inverted tooltip",
                                      attrs: {
                                        "data-tooltip": "Click to view",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(
                                            outstandingcredit.creditReturnMainID
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "icon is-medium" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-file-document mdi-24px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }
                        ),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }